type EventTeam = { id: string; workspace_id?: string | null; is_active?: boolean | null };

export function isEligibleAdditionalEventTeam(team: EventTeam | undefined, primary: EventTeam | null): boolean {
  return Boolean(team && primary?.workspace_id && team.id !== primary.id
    && team.is_active === true && team.workspace_id === primary.workspace_id);
}
